export default __webpack_public_path__ + "static/media/signal-bar-blue.572ddf76.svg";